import React, {FC, useEffect} from 'react';
import PaywallHomePage from './PaywallHomePage/PaywallHomePage';
import useAppNavigation from '@src/utils/useAppNavigation';
import {Routes} from '@src/Constant/routes';
import {IPaywallOrientation} from './PaywallSection.type';
import {
  PaywallSectionTrackingProps,
  PlayerPaywallTrackingProps,
} from '@src/Services/Amplitude/hooks/tracker';
import {trackEvent} from '@src/Tracking/trackEvent';
import {TraceTokEvents} from '@src/Tracking/catalog';

interface PaywallSectionPageProps {
  id?: string;
  variant?: 'paywall' | 'choosePlan';
  orientation?: IPaywallOrientation;
  trackingData: PlayerPaywallTrackingProps | PaywallSectionTrackingProps;
}

const PaywallSectionPage: FC<PaywallSectionPageProps> = ({
  id,
  variant = 'paywall',
  orientation = 'portrait',
  trackingData,
}) => {
  const navigation = useAppNavigation();

  useEffect(function trackOnOpened() {
    trackEvent(TraceTokEvents.PaywallViewed, {
      content_id: (trackingData as PlayerPaywallTrackingProps)?.id,
      paywall_context: variant,
      placement: (trackingData as PaywallSectionTrackingProps)?.source_type,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <PaywallHomePage
      variant={variant}
      orientation={orientation}
      id={id}
      onSelectPlan={() => navigation.navigate(Routes.CHOOSE_PLAN)}
    />
  );
};

export default PaywallSectionPage;
